"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeepLinkProvider = exports.initialState = void 0;

var _react = _interopRequireWildcard(require("react"));

var _split2 = _interopRequireDefault(require("lodash/split"));

var _replace2 = _interopRequireDefault(require("lodash/replace"));

var _parseInt2 = _interopRequireDefault(require("lodash/parseInt"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _types = require("../types");

var _utility = require("../utility");

var _reducer = require("./reducer");

var _context = require("./context");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var initialState = {
  promo: '',
  cart: [],
  itemType: ''
};
exports.initialState = initialState;

var DeepLinkProvider = function DeepLinkProvider(_a) {
  var children = _a.children;

  var _b; // tslint:disable-next-line: strict-type-predicates


  var params = typeof window !== 'undefined' && new URLSearchParams((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.search);
  var cartParams = params && (params === null || params === void 0 ? void 0 : params.get('cart'));
  var promo = params && (params === null || params === void 0 ? void 0 : params.get('promo')) || '';
  var cart = cartParams ? (0, _map2["default"])((0, _split2["default"])(cartParams, ','), _parseInt2["default"]) : [];
  var itemType = params && (params === null || params === void 0 ? void 0 : params.get('itemType')) || '';
  var defaultState = (0, _utility.getStorageState)(_types.StorageKeys.DeepLink) || initialState;
  var memoizedState = (0, _react.useMemo)(function () {
    return cart.length || promo || itemType ? {
      cart: cart,
      promo: promo,
      itemType: itemType
    } : defaultState;
  }, [cart, promo, itemType, defaultState]);

  var _c = (0, _react.useReducer)(_reducer.reducer, memoizedState),
      state = _c[0],
      dispatch = _c[1];

  (0, _react.useEffect)(function () {
    // tslint:disable-next-line: strict-type-predicates
    typeof window !== 'undefined' && state && window.history.replaceState({}, document.title, (0, _replace2["default"])(window.location.href, window.location.search, ''));
  }, []);
  (0, _react.useEffect)(function () {
    (0, _utility.setStorageState)(_types.StorageKeys.DeepLink, state);
  }, [state]);
  return _react["default"].createElement(_context.StateContext.Provider, {
    value: state
  }, _react["default"].createElement(_context.DispatchContext.Provider, {
    value: dispatch
  }, children));
};

exports.DeepLinkProvider = DeepLinkProvider;